var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"briller"}},[_c('NavBar'),_c('Banner'),_c('Carousel'),_c('MainMessage'),_c('CorporateAcrivity'),_c('AssociatedLocation'),_c('EmployeeRecruitment'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }